import axios from "axios";
export default {
    namespaced: true,
    state() {
        return {
            products: [],
        }
    },
    getters: {
        // productNavLabels(state) {
        //     const navLabels = []
        //     for (const item of state.products) {
        //         navLabels.push({ label: item.navLabel_en, icon: item.icon })
        //     }
        //     return navLabels
        // },
        fullNavLabels(state, _, _1, rootGetters) {
            const preferredLanguage = rootGetters['Profile/preferredLanguage']
            const navLabels = []
            // let productLabel = ''
            for (const item of state.products) {
                // preferredLanguage === 'en' && (productLabel = item.navLabel_en)
                // preferredLanguage === 'cn' && (productLabel = item.navLabel_cn)
                navLabels.push({
                    label: (() => {
                        return preferredLanguage === 'en' ? item.navLabel_en : item.navLabel_cn
                    })(), icon: item.icon
                })
            }

            navLabels.push({
                label: (() => {
                    return preferredLanguage === 'en' ? 'Promotions' : '优惠'
                })(), icon: 'gift'
            })
            navLabels.push({
                label: (() => {
                    return preferredLanguage === 'en' ? 'App' : '应用程序'
                })(), icon: 'mobile'
            })

            navLabels.forEach((item) => {
                item.isWrapped = false
                item.path = `/${item.label.toLowerCase()}`
            })
            return navLabels
        }
    },
    mutations: {
        updateProducts(state, payload) {
            state.products = payload
        }
    },
    actions: {
        async fetchProducts({ commit }) {
            await axios.get('https://qol-myaccount-default-rtdb.firebaseio.com/product.json')
                .then(res => (() => {
                    commit('updateProducts', res.data)
                })())
                .catch(error => alert(error.message))
        }
    }
}